var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://discord.gg/hU29ZUK","target":"_blank"}},[_c('div',{staticClass:"discord-container"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/img/icon/discord.png"),"alt":""}}),_c('div',{staticClass:"label"},[_vm._v("\n      "+_vm._s(_vm.fetchStatus === -1 || _vm.fetchStatus === 0
          ? 'GrandQuest server'
          : _vm.fetchStatus)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }